import {
  uploadPresignedFile,
  type UploadPresignedFileResult,
} from "@retro-ia/shared/upload";

export type ActividadProgramaArchivoSubcarpeta = "pdf" | "word";

export async function uploadActividadProgramaArchivo(
  file: File,
  programa: { cerebro: string },
  nombreActividad: string,
  subcarpeta: ActividadProgramaArchivoSubcarpeta,
): Promise<UploadPresignedFileResult> {
  return uploadPresignedFile({
    file,
    ruta: `private/${programa.cerebro}/actividades/${nombreActividad}/${subcarpeta}/${file.name}`,
    fileName: file.name,
    fileType: file.type,
    isPublic: true,
  });
}
